export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8947.339e3792.jpg";